






import { Component, Vue, Prop } from 'vue-property-decorator';
import { sessionModule } from '@/trials/store/modules/session';
import { SysConst as SC } from '@/trials/plugins/const';

import Highcharts from 'highcharts';
import histogram from 'highcharts/modules/histogram-bellcurve';
histogram(Highcharts);

import toHistogram from '@/trials/lib/highchartHelper/histogramConverter';

@Component
export default class MultiLabelHisogram extends Vue {
    /*----------------------------------*
     * Props
     *-----------------------------------*/
    @Prop(String) name: string;
    @Prop({ default: {} }) data: { [key: string]: any };
    @Prop(String) selector: string;
    @Prop() labels: any[];
    @Prop(String) legendTitle: string;

    /*----------------------------------*
     * Data
     *-----------------------------------*/

    /*----------------------------------*
     * Computed
     *-----------------------------------*/

    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    mounted() {
        this._drawChart();
    }

    /*----------------------------------*
     * Methods
     *-----------------------------------*/
    private _drawChart() {
        // 表示データ抽出
        const infoList = [];
        for (let i = 0; i < this.labels.length; i++) {
            const label = this.labels[i];
            const data = [...this.data[label]];

            infoList.push({
                name: label,
                data: data,
            });
        }
        const binaryData = toHistogram(infoList);

        // グラフの色を指定
        for (let i = 0; i < binaryData.series.length; i++) {
            const series: any = binaryData.series[i];
            series['color'] = series.name == 1 ? SC.Color.POSITIVE : SC.Color.NEGATIVE;
        }

        // 描画設定
        const chartParam: { [key: string]: any } = {
            chart: {
                type: 'column',
            },
            credits: {
                enabled: false,
            },
            title: {
                text: '',
            },

            xAxis: [
                {
                    categories: binaryData.categories,
                },
            ],

            yAxis: [
                {
                    title: { text: '' },
                },
            ],
            legend: {
                title: {
                    text: this.legendTitle,
                },
            },
            plotOptions: {
                column: {
                    accessibility: {
                        pointDescriptionFormatter: function(point: any) {
                            var ix = point.index + 1,
                                x1 = point.x.toFixed(3),
                                x2 = point.x2.toFixed(3),
                                val = point.y;
                            return ix + '. ' + x1 + ' to ' + x2 + ', ' + val + '.';
                        },
                    },
                    pointPadding: 0,
                    borderWidth: 0,
                    groupPadding: 0,
                    shadow: false,
                    stacking: 'normal',
                    dataLabels: {
                        enabled: true,
                    },
                },
            },

            series: binaryData.series,
        };
        Highcharts.chart(this.selector, chartParam);
    }
}
